export function createQuoteForPayoutV3(send) {
  return (payoutId, ...args) =>
    send(
      {
        path: '/v3/payouts/{payoutId}/quote',
        pathParameters: { payoutId },
        type: 'post',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
